
<template>
  <div>
    <CRow  class="justify-content-md-center">
      <CCol sm="8">
          <CCard>
            <CCardHeader>
              <CIcon name="cil-grid"/> パスワード変更
            </CCardHeader>
            <CCardBody>
              <CCol md="12" class="">
                  <label class="record-label pt-3">現在のパスワード</label>
                  <CInput placeholder="現在のパスワードを入力してください" type="password" :class="{ 'is-invalid': $v.currentPassword.$error }" v-model.trim="$v.currentPassword.$model" />
                  <div class="error" v-if="invalidPass">パスワードが違います</div>

                  <label class="record-label pt-3">新しいパスワード(半角英数大文字記号、8文字以上)</label>
                  <CInput placeholder="新しいパスワードを入力してください" type="password" :class="{ 'is-invalid': $v.newPassword.$error }" v-model.trim="$v.newPassword.$model" />
                  <div v-if="$v.newPassword.$error">
                    <div class="error" v-if="!$v.newPassword.required">新しいパスワードを入力してください</div>
                    <div class="error" v-if="!$v.newPassword.minLength">8文字以上にしてください</div>
                    <div class="error" v-if="!$v.newPassword.containsUppercase">大文字を入れてください</div>
                    <div class="error" v-if="!$v.newPassword.containsNumber">数字を入れてください</div>
                    <div class="error" v-if="!$v.newPassword.containsSpecial">記号を入れてください</div>
                  </div>


                  <label class="record-label pt-3">新しいパスワード(確認用)</label>
                  <CInput placeholder="新しいパスワード(確認用)を入力してください" type="password" :class="{ 'is-invalid': $v.newPasswordConfirm.$error }" v-model.trim="$v.newPasswordConfirm.$model" />
                  <div v-if="$v.newPasswordConfirm.$error">
                    <div class="error" v-if="!$v.newPasswordConfirm.required">新しいパスワード(確認用)は必須です</div>
                    <div class="error" v-if="!$v.newPasswordConfirm.sameAsPassword">新しいパスワードと一致しません</div>
                  </div>
                  <center>
                    <CButton color="info" class="mt-4"  @click="changePassword">変更する</CButton>
                  </center>
              </CCol>
            </CCardBody>
          </CCard>
      </CCol>
    </CRow>
  </div>
</template>
<script src="https://cdn.jsdelivr.net/npm/vue"></script>
<script>
import firebase from 'firebase'
import axios from 'axios';
import { required, minLength, sameAs } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex';
export default {
  components: {},
  data() {
    return {
      currentPassword: '',
      newPassword: '',
      newPasswordConfirm: '',
      invalidPass: false,
    }
  },
  validations: {
    currentPassword: {required},
    newPassword: {
      required,
      minLength: minLength(8),
      containsUppercase: function(value) {
          return /[A-Z]/.test(value)
        },
        containsLowercase: function(value) {
          return /[a-z]/.test(value)
        },
        containsNumber: function(value) {
          return /[0-9]/.test(value)
        },
        containsSpecial: function(value) {
          return /[#?!@$%^&amp;*-]/.test(value)
        },
    },
    newPasswordConfirm: {required,  sameAsPassword: sameAs('newPassword')},
  },
  methods: {
    changePassword: function() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        console.log("error")
      } else {
        console.log('success')
        const user = firebase.auth().currentUser
        // 再認証のcredentialを取得する
        const credential = firebase.auth.EmailAuthProvider.credential(
          user.email,
          this.currentPassword
        )
        console.log(this.currentPassword, user.email)
        // credentialをreauthenticateWithCredentialに渡す
        user.reauthenticateWithCredential(credential).then(() => {
          // 再認証に成功した場合のみ、updatePasswordメソッドを実行する
          user.updatePassword(this.newPassword).then(() => {
            this.$swal({
              icon: 'success',
              title: '変更できました',
            });
          }).catch((error) => {
            console.log(error)
          })
        }).catch((error) => {
          this.invalidPass = true
        })
        // axios
        //   .post(process.env.VUE_APP_API_ENDPOINT + "/news", {"news": this.news})
        //   .then(() => {
        //     this.$router.push("/news");
        //   }).catch(error => {
        //     console.log(error)
        //   })
      }
    }
  },
  mounted() {},
  computed: {
    ...mapGetters({
      idToken:'GetIdToken',
    })
  },

}
</script>
<style scoped lang="scss">
.error{
  color: red;
}
.is-invalid {
    border-color: red;
    input.form-control {
        border-color: red;
    }
}


</style>
